import { useLanguage } from '../utils/LanguageContext';
import { updateUserLanguagePreferenceSchema } from '../shared/validations/userValidations';
import { ValidatedForm, FormSubmit, FormChoice } from './common/ValidatedForm';
import { Language } from '../shared/constants/userConstants.js';
import { useAuth } from '../utils/AuthContext.js';

const LanguagePreferenceField = () => {
  const { optionsForEnum } = useLanguage();
  return <FormChoice name="languagePreference" options={optionsForEnum(Language)} type="radio" />;
};

const LanguagePreferenceForm = ({ onFinish, submitLabel }) => {
  const { setCurrentLanguage } = useLanguage();
  const { user, api } = useAuth();

  const handleSubmitAndUpdateLanguage = async (values) => {
    await api.updateUserLanguagePreference(values);
    const { languagePreference } = values;
    setCurrentLanguage(languagePreference);
  };

  return (
    <ValidatedForm
      key="userLanguagePreference"
      schema={updateUserLanguagePreferenceSchema}
      initialValues={{ languagePreference: user.languagePreference }}
      handleSubmit={handleSubmitAndUpdateLanguage}
      onFinish={onFinish}
    >
      <LanguagePreferenceField />
      <FormSubmit>{submitLabel}</FormSubmit>
    </ValidatedForm>
  );
};

export { LanguagePreferenceField };
export default LanguagePreferenceForm;
